/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopeAdHocTargetListDto,
  ApiEnvelopeVoteAdHocDto,
  ApiEnvelopeVoteAdHocListDto,
  ApiEnvelopeVoteAdminLogListDto,
  ApiEnvelopeVoteAdminProxyListDto,
  ApiEnvelopeVoteAdminStatsDto,
  ApiEnvelopeVoteAdminTodayDto,
  ApiEnvelopeVoteAttemptLogListDto,
  ApiEnvelopeVoteBoolResultDto,
  ApiEnvelopeVotePreviewListDto,
  ApiEnvelopeVoteResultDto,
  ApiEnvelopeVoteSiteListDto,
  ApiEnvelopeVoteStateListDto,
  ApiEnvelopeVotingAvailabilityDto,
  ApiEnvelopeVotingProxySyncReportDto,
  ApiEnvelopeVotingSchedulerStatusDto,
  ApiEnvelopeVotingSiteToggleDto,
  ApiEnvelopeVotingTickReportDto,
  ApiEnvelopeVotingTouchedResultDto,
  SetAdHocEnabledRequest,
  VoteAdHocCreateRequest,
  VotingAdminLogParams,
  VotingAdminStatsParams,
  VotingGetLogParams,
  VotingGetStateParams,
  VotingSetSiteEnabledRequest
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type votingGetSitesResponse200 = {
  data: ApiEnvelopeVoteSiteListDto
  status: 200
}

export type votingGetSitesResponseSuccess = (votingGetSitesResponse200) & {
  headers: Headers;
};
;

export type votingGetSitesResponse = (votingGetSitesResponseSuccess)

export const getVotingGetSitesUrl = () => {




  return `/api/voting/sites`
}

export const useVotingGetSitesHook = (): ( options?: RequestInit) => Promise<votingGetSitesResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getVotingGetSitesUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type votingGetStateResponse200 = {
  data: ApiEnvelopeVoteStateListDto
  status: 200
}

export type votingGetStateResponseSuccess = (votingGetStateResponse200) & {
  headers: Headers;
};
;

export type votingGetStateResponse = (votingGetStateResponseSuccess)

export const getVotingGetStateUrl = (params?: VotingGetStateParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/voting/state?${stringifiedParams}` : `/api/voting/state`
}

export const useVotingGetStateHook = (): (params?: VotingGetStateParams, options?: RequestInit) => Promise<votingGetStateResponse> => {

      const customFetcher = useSfetchMutator();
      return (params?: VotingGetStateParams, options?: RequestInit) => {

        return customFetcher(getVotingGetStateUrl(params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type votingGetLogResponse200 = {
  data: ApiEnvelopeVoteAttemptLogListDto
  status: 200
}

export type votingGetLogResponseSuccess = (votingGetLogResponse200) & {
  headers: Headers;
};
;

export type votingGetLogResponse = (votingGetLogResponseSuccess)

export const getVotingGetLogUrl = (params?: VotingGetLogParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/voting/log?${stringifiedParams}` : `/api/voting/log`
}

export const useVotingGetLogHook = (): (params?: VotingGetLogParams, options?: RequestInit) => Promise<votingGetLogResponse> => {

      const customFetcher = useSfetchMutator();
      return (params?: VotingGetLogParams, options?: RequestInit) => {

        return customFetcher(getVotingGetLogUrl(params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type votingAvailabilityResponse200 = {
  data: ApiEnvelopeVotingAvailabilityDto
  status: 200
}

export type votingAvailabilityResponseSuccess = (votingAvailabilityResponse200) & {
  headers: Headers;
};
;

export type votingAvailabilityResponse = (votingAvailabilityResponseSuccess)

export const getVotingAvailabilityUrl = () => {




  return `/api/voting/availability`
}

export const useVotingAvailabilityHook = (): ( options?: RequestInit) => Promise<votingAvailabilityResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getVotingAvailabilityUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type votingMyAdHocResponse200 = {
  data: ApiEnvelopeAdHocTargetListDto
  status: 200
}

export type votingMyAdHocResponseSuccess = (votingMyAdHocResponse200) & {
  headers: Headers;
};
;

export type votingMyAdHocResponse = (votingMyAdHocResponseSuccess)

export const getVotingMyAdHocUrl = () => {




  return `/api/voting/adhoc`
}

export const useVotingMyAdHocHook = (): ( options?: RequestInit) => Promise<votingMyAdHocResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getVotingMyAdHocUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type votingCreateMyAdHocResponse200 = {
  data: ApiEnvelopeVoteBoolResultDto
  status: 200
}

export type votingCreateMyAdHocResponse400 = {
  data: ApiEnvelopeVoteBoolResultDto
  status: 400
}

export type votingCreateMyAdHocResponseSuccess = (votingCreateMyAdHocResponse200) & {
  headers: Headers;
};
export type votingCreateMyAdHocResponseError = (votingCreateMyAdHocResponse400) & {
  headers: Headers;
};

export type votingCreateMyAdHocResponse = (votingCreateMyAdHocResponseSuccess | votingCreateMyAdHocResponseError)

export const getVotingCreateMyAdHocUrl = () => {




  return `/api/voting/adhoc`
}

export const useVotingCreateMyAdHocHook = (): (voteAdHocCreateRequest?: VoteAdHocCreateRequest, options?: RequestInit) => Promise<votingCreateMyAdHocResponse> => {

      const customFetcher = useSfetchMutator();
      return (voteAdHocCreateRequest?: VoteAdHocCreateRequest, options?: RequestInit) => {

        return customFetcher(getVotingCreateMyAdHocUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(voteAdHocCreateRequest)
  }
);
      }
  }


export type votingDeleteMyAdHocByUsernameResponse200 = {
  data: ApiEnvelopeVoteBoolResultDto
  status: 200
}

export type votingDeleteMyAdHocByUsernameResponse404 = {
  data: ApiEnvelopeVoteBoolResultDto
  status: 404
}

export type votingDeleteMyAdHocByUsernameResponseSuccess = (votingDeleteMyAdHocByUsernameResponse200) & {
  headers: Headers;
};
export type votingDeleteMyAdHocByUsernameResponseError = (votingDeleteMyAdHocByUsernameResponse404) & {
  headers: Headers;
};

export type votingDeleteMyAdHocByUsernameResponse = (votingDeleteMyAdHocByUsernameResponseSuccess | votingDeleteMyAdHocByUsernameResponseError)

export const getVotingDeleteMyAdHocByUsernameUrl = (username: string,) => {




  return `/api/voting/adhoc/${username}`
}

export const useVotingDeleteMyAdHocByUsernameHook = (): (username: string, options?: RequestInit) => Promise<votingDeleteMyAdHocByUsernameResponse> => {

      const customFetcher = useSfetchMutator();
      return (username: string, options?: RequestInit) => {

        return customFetcher(getVotingDeleteMyAdHocByUsernameUrl(username),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type votingRunResponse200 = {
  data: ApiEnvelopeVoteResultDto
  status: 200
}

export type votingRunResponseSuccess = (votingRunResponse200) & {
  headers: Headers;
};
;

export type votingRunResponse = (votingRunResponseSuccess)

export const getVotingRunUrl = (botId: string,
    siteKey: string,) => {




  return `/api/voting/run/${botId}/${siteKey}`
}

export const useVotingRunHook = (): (botId: string,
    siteKey: string, options?: RequestInit) => Promise<votingRunResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    siteKey: string, options?: RequestInit) => {

        return customFetcher(getVotingRunUrl(botId,siteKey),
  {
    ...options,
    method: 'POST'


  }
);
      }
  }


export type votingPreviewResponse200 = {
  data: ApiEnvelopeVotePreviewListDto
  status: 200
}

export type votingPreviewResponseSuccess = (votingPreviewResponse200) & {
  headers: Headers;
};
;

export type votingPreviewResponse = (votingPreviewResponseSuccess)

export const getVotingPreviewUrl = () => {




  return `/api/voting/preview`
}

export const useVotingPreviewHook = (): ( options?: RequestInit) => Promise<votingPreviewResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getVotingPreviewUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type votingSchedulerStatusResponse200 = {
  data: ApiEnvelopeVotingSchedulerStatusDto
  status: 200
}

export type votingSchedulerStatusResponseSuccess = (votingSchedulerStatusResponse200) & {
  headers: Headers;
};
;

export type votingSchedulerStatusResponse = (votingSchedulerStatusResponseSuccess)

export const getVotingSchedulerStatusUrl = () => {




  return `/api/voting/scheduler-status`
}

export const useVotingSchedulerStatusHook = (): ( options?: RequestInit) => Promise<votingSchedulerStatusResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getVotingSchedulerStatusUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type votingAdHocListResponse200 = {
  data: ApiEnvelopeVoteAdHocListDto
  status: 200
}

export type votingAdHocListResponseSuccess = (votingAdHocListResponse200) & {
  headers: Headers;
};
;

export type votingAdHocListResponse = (votingAdHocListResponseSuccess)

export const getVotingAdHocListUrl = () => {




  return `/api/voting/admin/adhoc`
}

export const useVotingAdHocListHook = (): ( options?: RequestInit) => Promise<votingAdHocListResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getVotingAdHocListUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type votingAdHocCreateResponse200 = {
  data: ApiEnvelopeVoteAdHocDto
  status: 200
}

export type votingAdHocCreateResponse400 = {
  data: ApiEnvelopeVoteAdHocDto
  status: 400
}

export type votingAdHocCreateResponseSuccess = (votingAdHocCreateResponse200) & {
  headers: Headers;
};
export type votingAdHocCreateResponseError = (votingAdHocCreateResponse400) & {
  headers: Headers;
};

export type votingAdHocCreateResponse = (votingAdHocCreateResponseSuccess | votingAdHocCreateResponseError)

export const getVotingAdHocCreateUrl = () => {




  return `/api/voting/admin/adhoc`
}

export const useVotingAdHocCreateHook = (): (voteAdHocCreateRequest?: VoteAdHocCreateRequest, options?: RequestInit) => Promise<votingAdHocCreateResponse> => {

      const customFetcher = useSfetchMutator();
      return (voteAdHocCreateRequest?: VoteAdHocCreateRequest, options?: RequestInit) => {

        return customFetcher(getVotingAdHocCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(voteAdHocCreateRequest)
  }
);
      }
  }


export type votingAdHocDeleteResponse200 = {
  data: ApiEnvelopeVoteBoolResultDto
  status: 200
}

export type votingAdHocDeleteResponse404 = {
  data: ApiEnvelopeVoteBoolResultDto
  status: 404
}

export type votingAdHocDeleteResponseSuccess = (votingAdHocDeleteResponse200) & {
  headers: Headers;
};
export type votingAdHocDeleteResponseError = (votingAdHocDeleteResponse404) & {
  headers: Headers;
};

export type votingAdHocDeleteResponse = (votingAdHocDeleteResponseSuccess | votingAdHocDeleteResponseError)

export const getVotingAdHocDeleteUrl = (id: string,) => {




  return `/api/voting/admin/adhoc/${id}`
}

export const useVotingAdHocDeleteHook = (): (id: string, options?: RequestInit) => Promise<votingAdHocDeleteResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getVotingAdHocDeleteUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type votingAdHocSetEnabledResponse200 = {
  data: ApiEnvelopeVoteAdHocDto
  status: 200
}

export type votingAdHocSetEnabledResponse400 = {
  data: ApiEnvelopeVoteAdHocDto
  status: 400
}

export type votingAdHocSetEnabledResponse404 = {
  data: ApiEnvelopeVoteAdHocDto
  status: 404
}

export type votingAdHocSetEnabledResponseSuccess = (votingAdHocSetEnabledResponse200) & {
  headers: Headers;
};
export type votingAdHocSetEnabledResponseError = (votingAdHocSetEnabledResponse400 | votingAdHocSetEnabledResponse404) & {
  headers: Headers;
};

export type votingAdHocSetEnabledResponse = (votingAdHocSetEnabledResponseSuccess | votingAdHocSetEnabledResponseError)

export const getVotingAdHocSetEnabledUrl = (id: string,) => {




  return `/api/voting/admin/adhoc/${id}`
}

export const useVotingAdHocSetEnabledHook = (): (id: string,
    setAdHocEnabledRequest?: SetAdHocEnabledRequest, options?: RequestInit) => Promise<votingAdHocSetEnabledResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    setAdHocEnabledRequest?: SetAdHocEnabledRequest, options?: RequestInit) => {

        return customFetcher(getVotingAdHocSetEnabledUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(setAdHocEnabledRequest)
  }
);
      }
  }


export type votingRunTickResponse200 = {
  data: ApiEnvelopeVotingTickReportDto
  status: 200
}

export type votingRunTickResponseSuccess = (votingRunTickResponse200) & {
  headers: Headers;
};
;

export type votingRunTickResponse = (votingRunTickResponseSuccess)

export const getVotingRunTickUrl = () => {




  return `/api/voting/run-tick`
}

export const useVotingRunTickHook = (): ( options?: RequestInit) => Promise<votingRunTickResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getVotingRunTickUrl(),
  {
    ...options,
    method: 'POST'


  }
);
      }
  }


export type votingAdminTodayResponse200 = {
  data: ApiEnvelopeVoteAdminTodayDto
  status: 200
}

export type votingAdminTodayResponseSuccess = (votingAdminTodayResponse200) & {
  headers: Headers;
};
;

export type votingAdminTodayResponse = (votingAdminTodayResponseSuccess)

export const getVotingAdminTodayUrl = () => {




  return `/api/voting/admin/today`
}

export const useVotingAdminTodayHook = (): ( options?: RequestInit) => Promise<votingAdminTodayResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getVotingAdminTodayUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type votingAdminStatsResponse200 = {
  data: ApiEnvelopeVoteAdminStatsDto
  status: 200
}

export type votingAdminStatsResponseSuccess = (votingAdminStatsResponse200) & {
  headers: Headers;
};
;

export type votingAdminStatsResponse = (votingAdminStatsResponseSuccess)

export const getVotingAdminStatsUrl = (params?: VotingAdminStatsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/voting/admin/stats?${stringifiedParams}` : `/api/voting/admin/stats`
}

export const useVotingAdminStatsHook = (): (params?: VotingAdminStatsParams, options?: RequestInit) => Promise<votingAdminStatsResponse> => {

      const customFetcher = useSfetchMutator();
      return (params?: VotingAdminStatsParams, options?: RequestInit) => {

        return customFetcher(getVotingAdminStatsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type votingAdminLogResponse200 = {
  data: ApiEnvelopeVoteAdminLogListDto
  status: 200
}

export type votingAdminLogResponseSuccess = (votingAdminLogResponse200) & {
  headers: Headers;
};
;

export type votingAdminLogResponse = (votingAdminLogResponseSuccess)

export const getVotingAdminLogUrl = (params?: VotingAdminLogParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/voting/admin/log?${stringifiedParams}` : `/api/voting/admin/log`
}

export const useVotingAdminLogHook = (): (params?: VotingAdminLogParams, options?: RequestInit) => Promise<votingAdminLogResponse> => {

      const customFetcher = useSfetchMutator();
      return (params?: VotingAdminLogParams, options?: RequestInit) => {

        return customFetcher(getVotingAdminLogUrl(params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type votingAdminResetFailuresResponse200 = {
  data: ApiEnvelopeVotingTouchedResultDto
  status: 200
}

export type votingAdminResetFailuresResponseSuccess = (votingAdminResetFailuresResponse200) & {
  headers: Headers;
};
;

export type votingAdminResetFailuresResponse = (votingAdminResetFailuresResponseSuccess)

export const getVotingAdminResetFailuresUrl = () => {




  return `/api/voting/admin/reset-failures`
}

export const useVotingAdminResetFailuresHook = (): ( options?: RequestInit) => Promise<votingAdminResetFailuresResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getVotingAdminResetFailuresUrl(),
  {
    ...options,
    method: 'POST'


  }
);
      }
  }


export type votingSetSiteEnabledResponse200 = {
  data: ApiEnvelopeVotingSiteToggleDto
  status: 200
}

export type votingSetSiteEnabledResponse404 = {
  data: ApiEnvelopeVotingSiteToggleDto
  status: 404
}

export type votingSetSiteEnabledResponseSuccess = (votingSetSiteEnabledResponse200) & {
  headers: Headers;
};
export type votingSetSiteEnabledResponseError = (votingSetSiteEnabledResponse404) & {
  headers: Headers;
};

export type votingSetSiteEnabledResponse = (votingSetSiteEnabledResponseSuccess | votingSetSiteEnabledResponseError)

export const getVotingSetSiteEnabledUrl = (siteKey: string,) => {




  return `/api/voting/admin/sites/${siteKey}`
}

export const useVotingSetSiteEnabledHook = (): (siteKey: string,
    votingSetSiteEnabledRequest?: VotingSetSiteEnabledRequest, options?: RequestInit) => Promise<votingSetSiteEnabledResponse> => {

      const customFetcher = useSfetchMutator();
      return (siteKey: string,
    votingSetSiteEnabledRequest?: VotingSetSiteEnabledRequest, options?: RequestInit) => {

        return customFetcher(getVotingSetSiteEnabledUrl(siteKey),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(votingSetSiteEnabledRequest)
  }
);
      }
  }


export type votingAdminClearStaleResponse200 = {
  data: ApiEnvelopeVoteBoolResultDto
  status: 200
}

export type votingAdminClearStaleResponse404 = {
  data: ApiEnvelopeVoteBoolResultDto
  status: 404
}

export type votingAdminClearStaleResponseSuccess = (votingAdminClearStaleResponse200) & {
  headers: Headers;
};
export type votingAdminClearStaleResponseError = (votingAdminClearStaleResponse404) & {
  headers: Headers;
};

export type votingAdminClearStaleResponse = (votingAdminClearStaleResponseSuccess | votingAdminClearStaleResponseError)

export const getVotingAdminClearStaleUrl = (botId: string,
    siteKey: string,) => {




  return `/api/voting/admin/state/${botId}/${siteKey}/clear-stale`
}

export const useVotingAdminClearStaleHook = (): (botId: string,
    siteKey: string, options?: RequestInit) => Promise<votingAdminClearStaleResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    siteKey: string, options?: RequestInit) => {

        return customFetcher(getVotingAdminClearStaleUrl(botId,siteKey),
  {
    ...options,
    method: 'POST'


  }
);
      }
  }


export type votingAdminProxiesResponse200 = {
  data: ApiEnvelopeVoteAdminProxyListDto
  status: 200
}

export type votingAdminProxiesResponseSuccess = (votingAdminProxiesResponse200) & {
  headers: Headers;
};
;

export type votingAdminProxiesResponse = (votingAdminProxiesResponseSuccess)

export const getVotingAdminProxiesUrl = () => {




  return `/api/voting/admin/proxies`
}

export const useVotingAdminProxiesHook = (): ( options?: RequestInit) => Promise<votingAdminProxiesResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getVotingAdminProxiesUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type votingAdminProxySyncResponse200 = {
  data: ApiEnvelopeVotingProxySyncReportDto
  status: 200
}

export type votingAdminProxySyncResponse400 = {
  data: ApiEnvelopeVotingProxySyncReportDto
  status: 400
}

export type votingAdminProxySyncResponseSuccess = (votingAdminProxySyncResponse200) & {
  headers: Headers;
};
export type votingAdminProxySyncResponseError = (votingAdminProxySyncResponse400) & {
  headers: Headers;
};

export type votingAdminProxySyncResponse = (votingAdminProxySyncResponseSuccess | votingAdminProxySyncResponseError)

export const getVotingAdminProxySyncUrl = () => {




  return `/api/voting/admin/proxies/sync`
}

export const useVotingAdminProxySyncHook = (): ( options?: RequestInit) => Promise<votingAdminProxySyncResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getVotingAdminProxySyncUrl(),
  {
    ...options,
    method: 'POST'


  }
);
      }
  }


export type votingAdminProxyReplaceResponse200 = {
  data: ApiEnvelopeVoteBoolResultDto
  status: 200
}

export type votingAdminProxyReplaceResponse400 = {
  data: ApiEnvelopeVoteBoolResultDto
  status: 400
}

export type votingAdminProxyReplaceResponse404 = {
  data: ApiEnvelopeVoteBoolResultDto
  status: 404
}

export type votingAdminProxyReplaceResponseSuccess = (votingAdminProxyReplaceResponse200) & {
  headers: Headers;
};
export type votingAdminProxyReplaceResponseError = (votingAdminProxyReplaceResponse400 | votingAdminProxyReplaceResponse404) & {
  headers: Headers;
};

export type votingAdminProxyReplaceResponse = (votingAdminProxyReplaceResponseSuccess | votingAdminProxyReplaceResponseError)

export const getVotingAdminProxyReplaceUrl = (id: string,) => {




  return `/api/voting/admin/proxies/${id}/replace`
}

export const useVotingAdminProxyReplaceHook = (): (id: string, options?: RequestInit) => Promise<votingAdminProxyReplaceResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getVotingAdminProxyReplaceUrl(id),
  {
    ...options,
    method: 'POST'


  }
);
      }
  }


export type votingAdminForceStaleResponse200 = {
  data: ApiEnvelopeVoteBoolResultDto
  status: 200
}

export type votingAdminForceStaleResponse404 = {
  data: ApiEnvelopeVoteBoolResultDto
  status: 404
}

export type votingAdminForceStaleResponseSuccess = (votingAdminForceStaleResponse200) & {
  headers: Headers;
};
export type votingAdminForceStaleResponseError = (votingAdminForceStaleResponse404) & {
  headers: Headers;
};

export type votingAdminForceStaleResponse = (votingAdminForceStaleResponseSuccess | votingAdminForceStaleResponseError)

export const getVotingAdminForceStaleUrl = (botId: string,
    siteKey: string,) => {




  return `/api/voting/admin/state/${botId}/${siteKey}/force-stale`
}

export const useVotingAdminForceStaleHook = (): (botId: string,
    siteKey: string, options?: RequestInit) => Promise<votingAdminForceStaleResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    siteKey: string, options?: RequestInit) => {

        return customFetcher(getVotingAdminForceStaleUrl(botId,siteKey),
  {
    ...options,
    method: 'POST'


  }
);
      }
  }


